export default __webpack_public_path__ + "static/media/headshot-blue.50c7419e.jpg";